<input
  type="file"
  id="import-individual-main"
  accept=".csv,.xlsx"
  (change)="onIndividualFileSelect($event)"
  hidden
  #individualFileInput />
<input
  type="file"
  id="import-legal-main"
  accept=".csv,.xlsx"
  (change)="onLegalFileSelect($event)"
  hidden
  #legalFileInput />

<app-user-individual-dialog
  [(visible)]="showIndividualDialog"
  [editingUserId]="editingUserId"
  [userData]="currentIndividualData"
  [rolesData]="rolesData"
  [isLoading]="isLoading"
  [isSave]="isSave"
  [isSend]="isSend"
  (onSave)="onSaveIndividual($event)"
  (onSendLetter)="sendNewAccountLetter('individual')"></app-user-individual-dialog>

<app-user-legal-dialog
  [(visible)]="showLegalEntityDialog"
  [editingUserId]="editingUserId"
  [userData]="currentLegalData"
  [rolesData]="rolesData"
  [isLoading]="isLoading"
  [isSave]="isSave"
  [isSend]="isSend"
  (onSave)="onSaveLegal($event)"
  (onSendLetter)="sendNewAccountLetter('legal')"></app-user-legal-dialog>
